import { render, staticRenderFns } from "./BreakdownTable.vue?vue&type=template&id=15303028&scoped=true"
import script from "./BreakdownTable.vue?vue&type=script&lang=js"
export * from "./BreakdownTable.vue?vue&type=script&lang=js"
import style0 from "./BreakdownTable.vue?vue&type=style&index=0&id=15303028&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15303028",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15303028')) {
      api.createRecord('15303028', component.options)
    } else {
      api.reload('15303028', component.options)
    }
    module.hot.accept("./BreakdownTable.vue?vue&type=template&id=15303028&scoped=true", function () {
      api.rerender('15303028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/BreakdownTable.vue"
export default component.exports